import type { LngLatEntity } from '@/shared/entities/LngLatEntity'
import type { BranchContactEntity } from './BranchContactEntity'

export class ActiveBranchEntity {
  id?: number
  sid?: number
  brandImageUrl?: string | null
  name?: string | null
  locationName?: string | null
  locationAddressDescription?: string | null
  location?: LngLatEntity
  branchContacts?: Array<BranchContactEntity> | null
  numberOfActiveOrders?: number
}
